"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allNotificationsHide = allNotificationsHide;
exports.notificationHide = notificationHide;
exports.notificationShow = notificationShow;

var _constants = require("./constants");

var _uuid = require("uuid");

function notificationShow(message, messageType) {
  var id = (0, _uuid.v4)();
  return {
    type: _constants.NOTIFICATION_SHOW,
    id: id,
    message: message,
    messageType: messageType
  };
}

function notificationHide(id) {
  return {
    type: _constants.NOTIFICATION_HIDE,
    id: id
  };
}

function allNotificationsHide() {
  return {
    type: _constants.ALL_NOTIFICATIONS_HIDE
  };
}